export const addXToValue = (value: number) => `${value}x`
